import { orgAPI } from "@/api/api";
import type {
  ExecuteToolboxResponse,
  IntegrationConnection,
} from "@cohesive/api-client";
import type { MicrosoftTeamsOnlineRecordingEntity } from "@cohesive/api-entities";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

type MicrosoftTeamsMeetingsResponse = ExecuteToolboxResponse<
  MicrosoftTeamsOnlineRecordingEntity[]
>;

interface UseMicrosoftTeamsChatsProps {
  connection: IntegrationConnection;
  query?: string;
  options?: Partial<UseQueryOptions<MicrosoftTeamsMeetingsResponse, Error>>;
}

export function useMicrosoftTeamsMeetings({
  connection,
  query,
  options = {},
}: UseMicrosoftTeamsChatsProps) {
  return useQuery<MicrosoftTeamsMeetingsResponse>({
    queryKey: ["microsoft-teams-list-online-recordings", connection.id, query],
    queryFn: async () => {
      // Typed entities drive the rich meeting rows; their generic projections
      // ride along in data_generic and are what get placed on the canvas.
      return orgAPI.toolbox.execute<
        MicrosoftTeamsOnlineRecordingEntity[],
        Record<string, unknown>
      >({
        integration_connection_id: connection.id,
        action_name: "microsoft-teams-list-online-recordings",
        action_input: {
          subject: query,
        },
        entity_format: "both",
      });
    },
    enabled: !!connection.integration_id,
    staleTime: 1000 * 60,
    ...options,
  });
}
